import React from 'react';
import connectToStores from 'alt-store-connect';
import PageStore from '../../stores/page';
import ContainerWrapper from './container-wrapper';
import Model from '../../utils/model';
import '../../../css/page/page-editor.less';

@connectToStores
class PageEditorCanvas extends React.Component {

    static getStores() {
        return [PageStore];
    }

    static getPropsFromStores(props) {
        return {
            page: PageStore.getState().models[props.pageId],
        };
    }

    componentWillMount() {
        manywho.model.initializeModel(this.props.flowKey);
    }

    render() {
        const containers = Model.stripValues(this.props.containers);
        const components = Model.stripValues(this.props.components);
        manywho.model.setContainers(this.props.flowKey, containers, null, 'pageContainers');
        manywho.model.setComponents(this.props.flowKey, components, null);
        return (
            <div className="page-editor-canvas" id={this.props.pageId}>
                {containers
                    .sort((a, b) => parseInt(a.order, 10) - parseInt(b.order, 10))
                    .map(container => (
                        <ContainerWrapper
                            key={container.id}
                            page={this.props.page}
                            modelId={this.props.modelId}
                            pageId={this.props.pageId}
                            order={container.order}
                            isRoot
                            container={container}
                            components={components}
                            flowKey={this.props.flowKey}
                            allContainers={containers}
                        />))
                }
            </div>
        );

    }

}

export default PageEditorCanvas;
